var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_19_1",
    "data-name": "Component 19 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.639,
    viewBox: "0 0 328.639 328.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18719",
    "data-name": "Group 18719",
    transform: "translate(-171.117 -388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17858",
    "data-name": "Group 17858",
    transform: "translate(171.117 388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M165.319,329.639A164.319,164.319,0,1,1,329.639,165.319,164.32,164.32,0,0,1,165.319,329.639Zm0-29.876A134.443,134.443,0,1,0,30.876,165.319,134.442,134.442,0,0,0,165.319,299.763Z",
    transform: "translate(-1 -1)",
    fill: "#e6ca35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25345",
    "data-name": "Path 25345",
    d: "M8.743,47.446l54.4,54.4L159,5.977",
    transform: "translate(80.448 111.148)",
    fill: "none",
    stroke: "#e6ca35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.bbedb745293c08e44224751757c8657a.svg";
export { ForwardRef as ReactComponent };